import logoSrc from "@/projects/assets/rajnagar-logo.png";
import logoMeta from "@/projects/assets/rajnagar-logo.png.asset.json";

interface BrandLogoProps {
  className?: string;
  alt?: string;
}

/**
 * Official Rajnagar Gyanotsav 2.0 seal.
 * Uses the local PNG asset (see rajnagar-logo.png.asset.json).
 */
export function BrandLogo({
  className = "h-9 w-9",
  alt = "રાજનગર જ્ઞાનોત્સવ",
}: BrandLogoProps) {
  return (
    <img
      src={logoSrc}
      alt={alt}
      title={logoMeta.original_filename}
      className={`${className} shrink-0 object-contain`}
      loading="eager"
      decoding="async"
    />
  );
}
